module.exports = __webpack_public_path__ + "img/page.83c74f2c.png";